import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.856 8.565c1.081.647 1.081 2.223 0 2.87L7.503 16.43C6.398 17.09 5 16.29 5 14.995v-9.99C5 3.71 6.398 2.909 7.503 3.57l8.353 4.995z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
